export default "__VITE_ASSET__04560f8d__"